module.exports = __webpack_public_path__ + "b86200d896896927ecc3ad9c89437deb.png";